export const trackingEvents = {
  BULK_CANCEL_BOOKING: {
    SAVE: {
      CLICKED: 'bulk_cancel_booking.save.clicked',
    },
  },
}
